import React, {useEffect, useState} from 'react';
import './styles.scss';
import {BiArrowBack, BiHide, BiShow} from 'react-icons/bi';
import {categoryOptions} from '../../App';

export const MapLegend = () => {
  const defaultVisibility = sessionStorage.getItem('legendVisibility');
  const [isVisible, setIsVisible] = useState(
    defaultVisibility === null ? true : JSON.parse(defaultVisibility),
  );

  const toggle = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    // Save toggle state to session storage
    sessionStorage.setItem('legendVisibility', JSON.stringify(isVisible));
  }, [isVisible]);

  return (
    <div className={`MapLegend ${isVisible ? 'visible' : 'hidden'}`}>
      <p className="title">Legend</p>
      <div className="list">
        <div>
          <div className="legend-color korea"></div>
          <p>South Korea</p>
        </div>
        <div>
          <div className="legend-color japan"></div>
          <p>Japan</p>
        </div>
        <div>
          <div className="legend-color china"></div>
          <p>China</p>
        </div>
      </div>
      <div className="list">
        {categoryOptions.map((category) => (
          <div key={category.value}>
            {category.icon}
            <p>{category.label}</p>
          </div>
        ))}
      </div>
      <button className="hide-button">
        {isVisible ? (
          <BiHide onClick={toggle} />
        ) : (
          <BiShow onClick={toggle} />
        )}
      </button>
    </div>
  );
};
